<template>
  <div :class="['common-card']">
    <div class="common-card-block">
      <h3>{{ data.index }}</h3>
    </div>
    <strong class="text-font">{{ data.text }}</strong>
    <div class="common-card-but" v-if="data.but" @click="toLink(data.but)">
      <ButtonCommon type="infoMin" width="100%" height="32px"
        ><h6 class="h6-mini">{{ data.but.text }}</h6>
      </ButtonCommon>
    </div>
  </div>
</template>
<script>
import ButtonCommon from "@/components/Common/button.vue";
export default {
  name: "card",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: { ButtonCommon },
  methods: {
    toLink(data) {
      if (data.blank) {
        window.open(data.url, "_blank");
      } else {
        document.getElementById(data.url).scrollIntoView();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.common-card {
  position: relative;
  box-sizing: border-box;
  background-color: #191919;
  border: 1px solid;
  border-color: #2a524e;
  width: 100%;
  margin-bottom: 10px;
  padding: 12px 16px;
  border-radius: 5px;
  &:last-child {
    margin-bottom: 0;
  }

  .common-card-block {
    background-color: #191919;

    h3 {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid;
      border-color: #ffffff;
      width: 64px;
      height: 64px;
      border-radius: 50%;
      width: 36px;
      height: 36px;
      margin: 0 auto;
      font-size: 26px;
      line-height: 13px;
    }
  }

  strong {
    font-size: 14px;
    line-height: 18px;
  }

  .common-card-but {
    width: 80%;
    height: 32px;
    margin: 12px auto 8px;

    h6 {
      color: #191919;
    }
  }

  .common-card-block {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  h6 {
    margin-top: 20px;
    margin-bottom: 8px;
    margin-top: 0px;
    font-size: 19px;
    line-height: 24px;
    margin-bottom: 0px;
  }

  .text-font {
    display: block;
    color: #fff;
    opacity: 0.8;
    text-align: center;
    max-width: 227px;
    margin: auto;
  }
}
</style>
